import React from "react";
import "../../styles/services.css";

const serviceData = [
  {
    icon: "ri-seo-line",
    title: "SEO Optimization",
    desc: "Enhance your online visibility and organic traffic with our expert SEO strategies. We focus on keyword research, on-page optimization, and link building to improve your search rankings."
  },
  {
    icon: "ri-swap-line",
    title: "Social Media Management",
    desc: "Build and engage your audience with our comprehensive social media management services. We create tailored content strategies that resonate with your brand and drive engagement."
  },
  {
    icon: "ri-mail-line",
    title: "Email Marketing",
    desc: "Reach your customers directly with our targeted email marketing campaigns. We design compelling newsletters and promotional emails that convert leads into loyal customers."
  },
  {
    icon: "ri-bar-chart-line",
    title: "Analytics & Reporting",
    desc: "Make data-driven decisions with our detailed analytics and reporting services. We track your campaigns' performance to optimize your marketing strategies for better results."
  }
];

const Services = () => {
  return (
    <section id="service">
      <div className="container">
        <div className="services__top-content">
          <h6 className="subtitle">Our Services</h6>
          <h2>Maximize Your Online Impact with</h2>
          <h2 className="highlight">Our Expert Solutions</h2>
        </div>

        <div className="service__item-wrapper">
          {serviceData.map((item, index) => (
            <div className="services__item" key={index}>
              <span className="service__icon">
                <i className={item.icon}></i>
              </span>
              <h3 className="service__title">{item.title}</h3>
              <p className="description">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
